import FairComplete from "@src/pages/consulting/fair/Complete";
import { lazy } from "react";

const FairApplication = lazy(() => import("../pages/consulting/fair/Application"));

export const consultingRoutes = [
  // isInApp 쿼리스트링 필요. 앱 내에서 사용할경우 스킴사용, 외부일경우 라우터 사용
  { path: "/consulting/fair/application", element: <FairApplication /> },
  // isInApp 쿼리스트링 필요. 앱 내에서 사용할경우 스킴사용, 외부일경우 라우터 사용
  { path: "/consulting/fair/complete", element: <FairComplete /> },
];
